import * as i0 from '@angular/core';
import { Component, SkipSelf, Host, Input, NgModule, ContentChildren, Output, Inject } from '@angular/core';
import * as i1 from 'devextreme-angular/core';
import { NestedOption, NestedOptionHost, DxIntegrationModule, CollectionNestedOption, extractTemplate, DxTemplateHost } from 'devextreme-angular/core';
import { PROPERTY_TOKEN_toolbarItems, PROPERTY_TOKEN_items } from 'devextreme-angular/core/tokens';
import { DOCUMENT } from '@angular/common';

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
const _c0 = ["*"];
let DxoDropDownButtonAnimationComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonAnimationComponent extends NestedOption {
    get hide() {
      return this._getOption('hide');
    }
    set hide(value) {
      this._setOption('hide', value);
    }
    get show() {
      return this._getOption('show');
    }
    set show(value) {
      this._setOption('show', value);
    }
    get _optionPath() {
      return 'animation';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonAnimationComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonAnimationComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonAnimationComponent,
      selectors: [["dxo-drop-down-button-animation"]],
      inputs: {
        hide: "hide",
        show: "show"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonAnimationComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonAnimationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonAnimationModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonAnimationModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonAnimationModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonAnimationModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonAnimationModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonAnimationComponent]
    });
  }
  return DxoDropDownButtonAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonAtComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonAtComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'at';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonAtComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonAtComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonAtComponent,
      selectors: [["dxo-drop-down-button-at"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonAtComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonAtComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonAtModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonAtModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonAtModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonAtModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonAtModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonAtComponent]
    });
  }
  return DxoDropDownButtonAtModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonBoundaryOffsetComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonBoundaryOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'boundaryOffset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonBoundaryOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonBoundaryOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonBoundaryOffsetComponent,
      selectors: [["dxo-drop-down-button-boundary-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonBoundaryOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonBoundaryOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonBoundaryOffsetModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonBoundaryOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonBoundaryOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonBoundaryOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonBoundaryOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonBoundaryOffsetComponent]
    });
  }
  return DxoDropDownButtonBoundaryOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonCollisionComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonCollisionComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'collision';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonCollisionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonCollisionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonCollisionComponent,
      selectors: [["dxo-drop-down-button-collision"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonCollisionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonCollisionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonCollisionModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonCollisionModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonCollisionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonCollisionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonCollisionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonCollisionComponent]
    });
  }
  return DxoDropDownButtonCollisionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonDropDownOptionsComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonDropDownOptionsComponent extends NestedOption {
    set _toolbarItemsContentChildren(value) {
      this.setChildren('toolbarItems', value);
    }
    get accessKey() {
      return this._getOption('accessKey');
    }
    set accessKey(value) {
      this._setOption('accessKey', value);
    }
    get animation() {
      return this._getOption('animation');
    }
    set animation(value) {
      this._setOption('animation', value);
    }
    get container() {
      return this._getOption('container');
    }
    set container(value) {
      this._setOption('container', value);
    }
    get contentTemplate() {
      return this._getOption('contentTemplate');
    }
    set contentTemplate(value) {
      this._setOption('contentTemplate', value);
    }
    get deferRendering() {
      return this._getOption('deferRendering');
    }
    set deferRendering(value) {
      this._setOption('deferRendering', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get dragAndResizeArea() {
      return this._getOption('dragAndResizeArea');
    }
    set dragAndResizeArea(value) {
      this._setOption('dragAndResizeArea', value);
    }
    get dragEnabled() {
      return this._getOption('dragEnabled');
    }
    set dragEnabled(value) {
      this._setOption('dragEnabled', value);
    }
    get dragOutsideBoundary() {
      return this._getOption('dragOutsideBoundary');
    }
    set dragOutsideBoundary(value) {
      this._setOption('dragOutsideBoundary', value);
    }
    get enableBodyScroll() {
      return this._getOption('enableBodyScroll');
    }
    set enableBodyScroll(value) {
      this._setOption('enableBodyScroll', value);
    }
    get focusStateEnabled() {
      return this._getOption('focusStateEnabled');
    }
    set focusStateEnabled(value) {
      this._setOption('focusStateEnabled', value);
    }
    get fullScreen() {
      return this._getOption('fullScreen');
    }
    set fullScreen(value) {
      this._setOption('fullScreen', value);
    }
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    get hideOnOutsideClick() {
      return this._getOption('hideOnOutsideClick');
    }
    set hideOnOutsideClick(value) {
      this._setOption('hideOnOutsideClick', value);
    }
    get hideOnParentScroll() {
      return this._getOption('hideOnParentScroll');
    }
    set hideOnParentScroll(value) {
      this._setOption('hideOnParentScroll', value);
    }
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    get maxHeight() {
      return this._getOption('maxHeight');
    }
    set maxHeight(value) {
      this._setOption('maxHeight', value);
    }
    get maxWidth() {
      return this._getOption('maxWidth');
    }
    set maxWidth(value) {
      this._setOption('maxWidth', value);
    }
    get minHeight() {
      return this._getOption('minHeight');
    }
    set minHeight(value) {
      this._setOption('minHeight', value);
    }
    get minWidth() {
      return this._getOption('minWidth');
    }
    set minWidth(value) {
      this._setOption('minWidth', value);
    }
    get onContentReady() {
      return this._getOption('onContentReady');
    }
    set onContentReady(value) {
      this._setOption('onContentReady', value);
    }
    get onDisposing() {
      return this._getOption('onDisposing');
    }
    set onDisposing(value) {
      this._setOption('onDisposing', value);
    }
    get onHidden() {
      return this._getOption('onHidden');
    }
    set onHidden(value) {
      this._setOption('onHidden', value);
    }
    get onHiding() {
      return this._getOption('onHiding');
    }
    set onHiding(value) {
      this._setOption('onHiding', value);
    }
    get onInitialized() {
      return this._getOption('onInitialized');
    }
    set onInitialized(value) {
      this._setOption('onInitialized', value);
    }
    get onOptionChanged() {
      return this._getOption('onOptionChanged');
    }
    set onOptionChanged(value) {
      this._setOption('onOptionChanged', value);
    }
    get onResize() {
      return this._getOption('onResize');
    }
    set onResize(value) {
      this._setOption('onResize', value);
    }
    get onResizeEnd() {
      return this._getOption('onResizeEnd');
    }
    set onResizeEnd(value) {
      this._setOption('onResizeEnd', value);
    }
    get onResizeStart() {
      return this._getOption('onResizeStart');
    }
    set onResizeStart(value) {
      this._setOption('onResizeStart', value);
    }
    get onShowing() {
      return this._getOption('onShowing');
    }
    set onShowing(value) {
      this._setOption('onShowing', value);
    }
    get onShown() {
      return this._getOption('onShown');
    }
    set onShown(value) {
      this._setOption('onShown', value);
    }
    get onTitleRendered() {
      return this._getOption('onTitleRendered');
    }
    set onTitleRendered(value) {
      this._setOption('onTitleRendered', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get resizeEnabled() {
      return this._getOption('resizeEnabled');
    }
    set resizeEnabled(value) {
      this._setOption('resizeEnabled', value);
    }
    get restorePosition() {
      return this._getOption('restorePosition');
    }
    set restorePosition(value) {
      this._setOption('restorePosition', value);
    }
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    get shading() {
      return this._getOption('shading');
    }
    set shading(value) {
      this._setOption('shading', value);
    }
    get shadingColor() {
      return this._getOption('shadingColor');
    }
    set shadingColor(value) {
      this._setOption('shadingColor', value);
    }
    get showCloseButton() {
      return this._getOption('showCloseButton');
    }
    set showCloseButton(value) {
      this._setOption('showCloseButton', value);
    }
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    get tabIndex() {
      return this._getOption('tabIndex');
    }
    set tabIndex(value) {
      this._setOption('tabIndex', value);
    }
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    get titleTemplate() {
      return this._getOption('titleTemplate');
    }
    set titleTemplate(value) {
      this._setOption('titleTemplate', value);
    }
    get toolbarItems() {
      return this._getOption('toolbarItems');
    }
    set toolbarItems(value) {
      this._setOption('toolbarItems', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    get wrapperAttr() {
      return this._getOption('wrapperAttr');
    }
    set wrapperAttr(value) {
      this._setOption('wrapperAttr', value);
    }
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    positionChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get _optionPath() {
      return 'dropDownOptions';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      this._createEventEmitters([{
        emit: 'heightChange'
      }, {
        emit: 'positionChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonDropDownOptionsComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonDropDownOptionsComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonDropDownOptionsComponent,
      selectors: [["dxo-drop-down-button-drop-down-options"]],
      contentQueries: function DxoDropDownButtonDropDownOptionsComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, PROPERTY_TOKEN_toolbarItems, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._toolbarItemsContentChildren = _t);
        }
      },
      inputs: {
        accessKey: "accessKey",
        animation: "animation",
        container: "container",
        contentTemplate: "contentTemplate",
        deferRendering: "deferRendering",
        disabled: "disabled",
        dragAndResizeArea: "dragAndResizeArea",
        dragEnabled: "dragEnabled",
        dragOutsideBoundary: "dragOutsideBoundary",
        enableBodyScroll: "enableBodyScroll",
        focusStateEnabled: "focusStateEnabled",
        fullScreen: "fullScreen",
        height: "height",
        hideOnOutsideClick: "hideOnOutsideClick",
        hideOnParentScroll: "hideOnParentScroll",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        maxHeight: "maxHeight",
        maxWidth: "maxWidth",
        minHeight: "minHeight",
        minWidth: "minWidth",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onHidden: "onHidden",
        onHiding: "onHiding",
        onInitialized: "onInitialized",
        onOptionChanged: "onOptionChanged",
        onResize: "onResize",
        onResizeEnd: "onResizeEnd",
        onResizeStart: "onResizeStart",
        onShowing: "onShowing",
        onShown: "onShown",
        onTitleRendered: "onTitleRendered",
        position: "position",
        resizeEnabled: "resizeEnabled",
        restorePosition: "restorePosition",
        rtlEnabled: "rtlEnabled",
        shading: "shading",
        shadingColor: "shadingColor",
        showCloseButton: "showCloseButton",
        showTitle: "showTitle",
        tabIndex: "tabIndex",
        title: "title",
        titleTemplate: "titleTemplate",
        toolbarItems: "toolbarItems",
        visible: "visible",
        width: "width",
        wrapperAttr: "wrapperAttr"
      },
      outputs: {
        heightChange: "heightChange",
        positionChange: "positionChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonDropDownOptionsComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonDropDownOptionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonDropDownOptionsModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonDropDownOptionsModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonDropDownOptionsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonDropDownOptionsModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonDropDownOptionsModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonDropDownOptionsComponent]
    });
  }
  return DxoDropDownButtonDropDownOptionsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonFromComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonFromComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'from';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonFromComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonFromComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonFromComponent,
      selectors: [["dxo-drop-down-button-from"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonFromComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonFromComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonFromModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonFromModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonFromModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonFromModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonFromModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonFromComponent]
    });
  }
  return DxoDropDownButtonFromModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonHideComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonHideComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'hide';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonHideComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonHideComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonHideComponent,
      selectors: [["dxo-drop-down-button-hide"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonHideComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonHideComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonHideModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonHideModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonHideModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonHideModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonHideModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonHideComponent]
    });
  }
  return DxoDropDownButtonHideModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDropDownButtonItemComponent = /*#__PURE__*/(() => {
  class DxiDropDownButtonItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get badge() {
      return this._getOption('badge');
    }
    set badge(value) {
      this._setOption('badge', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get icon() {
      return this._getOption('icon');
    }
    set icon(value) {
      this._setOption('icon', value);
    }
    get onClick() {
      return this._getOption('onClick');
    }
    set onClick(value) {
      this._setOption('onClick', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get _optionPath() {
      return 'items';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDropDownButtonItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownButtonItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDropDownButtonItemComponent,
      selectors: [["dxi-drop-down-button-item"]],
      inputs: {
        badge: "badge",
        disabled: "disabled",
        html: "html",
        icon: "icon",
        onClick: "onClick",
        template: "template",
        text: "text",
        visible: "visible"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_items,
        useExisting: DxiDropDownButtonItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDropDownButtonItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDropDownButtonItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDropDownButtonItemModule = /*#__PURE__*/(() => {
  class DxiDropDownButtonItemModule {
    /** @nocollapse */static ɵfac = function DxiDropDownButtonItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownButtonItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDropDownButtonItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDropDownButtonItemComponent]
    });
  }
  return DxiDropDownButtonItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonMyComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonMyComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'my';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonMyComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonMyComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonMyComponent,
      selectors: [["dxo-drop-down-button-my"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonMyComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonMyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonMyModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonMyModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonMyModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonMyModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonMyModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonMyComponent]
    });
  }
  return DxoDropDownButtonMyModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonOffsetComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonOffsetComponent extends NestedOption {
    get x() {
      return this._getOption('x');
    }
    set x(value) {
      this._setOption('x', value);
    }
    get y() {
      return this._getOption('y');
    }
    set y(value) {
      this._setOption('y', value);
    }
    get _optionPath() {
      return 'offset';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonOffsetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonOffsetComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonOffsetComponent,
      selectors: [["dxo-drop-down-button-offset"]],
      inputs: {
        x: "x",
        y: "y"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonOffsetComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonOffsetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonOffsetModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonOffsetModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonOffsetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonOffsetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonOffsetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonOffsetComponent]
    });
  }
  return DxoDropDownButtonOffsetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonPositionComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonPositionComponent extends NestedOption {
    get at() {
      return this._getOption('at');
    }
    set at(value) {
      this._setOption('at', value);
    }
    get boundary() {
      return this._getOption('boundary');
    }
    set boundary(value) {
      this._setOption('boundary', value);
    }
    get boundaryOffset() {
      return this._getOption('boundaryOffset');
    }
    set boundaryOffset(value) {
      this._setOption('boundaryOffset', value);
    }
    get collision() {
      return this._getOption('collision');
    }
    set collision(value) {
      this._setOption('collision', value);
    }
    get my() {
      return this._getOption('my');
    }
    set my(value) {
      this._setOption('my', value);
    }
    get of() {
      return this._getOption('of');
    }
    set of(value) {
      this._setOption('of', value);
    }
    get offset() {
      return this._getOption('offset');
    }
    set offset(value) {
      this._setOption('offset', value);
    }
    get _optionPath() {
      return 'position';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonPositionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonPositionComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonPositionComponent,
      selectors: [["dxo-drop-down-button-position"]],
      inputs: {
        at: "at",
        boundary: "boundary",
        boundaryOffset: "boundaryOffset",
        collision: "collision",
        my: "my",
        of: "of",
        offset: "offset"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonPositionComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonPositionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonPositionModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonPositionModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonPositionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonPositionModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonPositionModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonPositionComponent]
    });
  }
  return DxoDropDownButtonPositionModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonShowComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonShowComponent extends NestedOption {
    get complete() {
      return this._getOption('complete');
    }
    set complete(value) {
      this._setOption('complete', value);
    }
    get delay() {
      return this._getOption('delay');
    }
    set delay(value) {
      this._setOption('delay', value);
    }
    get direction() {
      return this._getOption('direction');
    }
    set direction(value) {
      this._setOption('direction', value);
    }
    get duration() {
      return this._getOption('duration');
    }
    set duration(value) {
      this._setOption('duration', value);
    }
    get easing() {
      return this._getOption('easing');
    }
    set easing(value) {
      this._setOption('easing', value);
    }
    get from() {
      return this._getOption('from');
    }
    set from(value) {
      this._setOption('from', value);
    }
    get staggerDelay() {
      return this._getOption('staggerDelay');
    }
    set staggerDelay(value) {
      this._setOption('staggerDelay', value);
    }
    get start() {
      return this._getOption('start');
    }
    set start(value) {
      this._setOption('start', value);
    }
    get to() {
      return this._getOption('to');
    }
    set to(value) {
      this._setOption('to', value);
    }
    get type() {
      return this._getOption('type');
    }
    set type(value) {
      this._setOption('type', value);
    }
    get _optionPath() {
      return 'show';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonShowComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonShowComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonShowComponent,
      selectors: [["dxo-drop-down-button-show"]],
      inputs: {
        complete: "complete",
        delay: "delay",
        direction: "direction",
        duration: "duration",
        easing: "easing",
        from: "from",
        staggerDelay: "staggerDelay",
        start: "start",
        to: "to",
        type: "type"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonShowComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonShowComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonShowModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonShowModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonShowModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonShowModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonShowModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonShowComponent]
    });
  }
  return DxoDropDownButtonShowModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxoDropDownButtonToComponent = /*#__PURE__*/(() => {
  class DxoDropDownButtonToComponent extends NestedOption {
    get left() {
      return this._getOption('left');
    }
    set left(value) {
      this._setOption('left', value);
    }
    get opacity() {
      return this._getOption('opacity');
    }
    set opacity(value) {
      this._setOption('opacity', value);
    }
    get position() {
      return this._getOption('position');
    }
    set position(value) {
      this._setOption('position', value);
    }
    get scale() {
      return this._getOption('scale');
    }
    set scale(value) {
      this._setOption('scale', value);
    }
    get top() {
      return this._getOption('top');
    }
    set top(value) {
      this._setOption('top', value);
    }
    get _optionPath() {
      return 'to';
    }
    constructor(parentOptionHost, optionHost) {
      super();
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    ngOnInit() {
      this._addRecreatedComponent();
    }
    ngOnDestroy() {
      this._addRemovedOption(this._getOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxoDropDownButtonToComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonToComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxoDropDownButtonToComponent,
      selectors: [["dxo-drop-down-button-to"]],
      inputs: {
        left: "left",
        opacity: "opacity",
        position: "position",
        scale: "scale",
        top: "top"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function DxoDropDownButtonToComponent_Template(rf, ctx) {},
      dependencies: [DxIntegrationModule],
      encapsulation: 2
    });
  }
  return DxoDropDownButtonToComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxoDropDownButtonToModule = /*#__PURE__*/(() => {
  class DxoDropDownButtonToModule {
    /** @nocollapse */static ɵfac = function DxoDropDownButtonToModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxoDropDownButtonToModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxoDropDownButtonToModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxoDropDownButtonToComponent]
    });
  }
  return DxoDropDownButtonToModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
let DxiDropDownButtonToolbarItemComponent = /*#__PURE__*/(() => {
  class DxiDropDownButtonToolbarItemComponent extends CollectionNestedOption {
    renderer;
    document;
    element;
    get cssClass() {
      return this._getOption('cssClass');
    }
    set cssClass(value) {
      this._setOption('cssClass', value);
    }
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    get html() {
      return this._getOption('html');
    }
    set html(value) {
      this._setOption('html', value);
    }
    get locateInMenu() {
      return this._getOption('locateInMenu');
    }
    set locateInMenu(value) {
      this._setOption('locateInMenu', value);
    }
    get location() {
      return this._getOption('location');
    }
    set location(value) {
      this._setOption('location', value);
    }
    get menuItemTemplate() {
      return this._getOption('menuItemTemplate');
    }
    set menuItemTemplate(value) {
      this._setOption('menuItemTemplate', value);
    }
    get options() {
      return this._getOption('options');
    }
    set options(value) {
      this._setOption('options', value);
    }
    get showText() {
      return this._getOption('showText');
    }
    set showText(value) {
      this._setOption('showText', value);
    }
    get template() {
      return this._getOption('template');
    }
    set template(value) {
      this._setOption('template', value);
    }
    get text() {
      return this._getOption('text');
    }
    set text(value) {
      this._setOption('text', value);
    }
    get toolbar() {
      return this._getOption('toolbar');
    }
    set toolbar(value) {
      this._setOption('toolbar', value);
    }
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    get widget() {
      return this._getOption('widget');
    }
    set widget(value) {
      this._setOption('widget', value);
    }
    get _optionPath() {
      return 'toolbarItems';
    }
    constructor(parentOptionHost, optionHost, renderer, document, templateHost, element) {
      super();
      this.renderer = renderer;
      this.document = document;
      this.element = element;
      parentOptionHost.setNestedOption(this);
      optionHost.setHost(this, this._fullOptionPath.bind(this));
      templateHost.setHost(this);
    }
    setTemplate(template) {
      this.template = template;
    }
    ngAfterViewInit() {
      extractTemplate(this, this.element, this.renderer, this.document);
    }
    ngOnDestroy() {
      this._deleteRemovedOptions(this._fullOptionPath());
    }
    /** @nocollapse */
    static ɵfac = function DxiDropDownButtonToolbarItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownButtonToolbarItemComponent)(i0.ɵɵdirectiveInject(i1.NestedOptionHost, 5), i0.ɵɵdirectiveInject(i1.NestedOptionHost, 1), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.DxTemplateHost, 1), i0.ɵɵdirectiveInject(i0.ElementRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxiDropDownButtonToolbarItemComponent,
      selectors: [["dxi-drop-down-button-toolbar-item"]],
      inputs: {
        cssClass: "cssClass",
        disabled: "disabled",
        html: "html",
        locateInMenu: "locateInMenu",
        location: "location",
        menuItemTemplate: "menuItemTemplate",
        options: "options",
        showText: "showText",
        template: "template",
        text: "text",
        toolbar: "toolbar",
        visible: "visible",
        widget: "widget"
      },
      features: [i0.ɵɵProvidersFeature([NestedOptionHost, DxTemplateHost, {
        provide: PROPERTY_TOKEN_toolbarItems,
        useExisting: DxiDropDownButtonToolbarItemComponent
      }]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function DxiDropDownButtonToolbarItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      dependencies: [DxIntegrationModule],
      styles: ["[_nghost-%COMP%]{display:block}"]
    });
  }
  return DxiDropDownButtonToolbarItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxiDropDownButtonToolbarItemModule = /*#__PURE__*/(() => {
  class DxiDropDownButtonToolbarItemModule {
    /** @nocollapse */static ɵfac = function DxiDropDownButtonToolbarItemModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxiDropDownButtonToolbarItemModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxiDropDownButtonToolbarItemModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiDropDownButtonToolbarItemComponent]
    });
  }
  return DxiDropDownButtonToolbarItemModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*!
 * devextreme-angular
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxiDropDownButtonItemComponent, DxiDropDownButtonItemModule, DxiDropDownButtonToolbarItemComponent, DxiDropDownButtonToolbarItemModule, DxoDropDownButtonAnimationComponent, DxoDropDownButtonAnimationModule, DxoDropDownButtonAtComponent, DxoDropDownButtonAtModule, DxoDropDownButtonBoundaryOffsetComponent, DxoDropDownButtonBoundaryOffsetModule, DxoDropDownButtonCollisionComponent, DxoDropDownButtonCollisionModule, DxoDropDownButtonDropDownOptionsComponent, DxoDropDownButtonDropDownOptionsModule, DxoDropDownButtonFromComponent, DxoDropDownButtonFromModule, DxoDropDownButtonHideComponent, DxoDropDownButtonHideModule, DxoDropDownButtonMyComponent, DxoDropDownButtonMyModule, DxoDropDownButtonOffsetComponent, DxoDropDownButtonOffsetModule, DxoDropDownButtonPositionComponent, DxoDropDownButtonPositionModule, DxoDropDownButtonShowComponent, DxoDropDownButtonShowModule, DxoDropDownButtonToComponent, DxoDropDownButtonToModule };
